<template>
    <div>
        <div class="nav primary-bg pl20 pr20 pt10 pb10">
            <div class="box-horizontal">
                <div class="" @click="met.back()">
                    <img src="@/assets/back.png" alt="" style="height:30px">
                </div>
                <div class="flex-1 f13 text-center white">
                    Detail
                </div>
                <div class=""></div>
            </div>
        </div>
        <div class="wrapper">
            <div class="body">
                <div class="bg-round-white mt10 p10" v-if="get.data.stat_online != null">
                    <span class="block gray mb5">
                        Via
                    </span>
                    <div v-if="get.data.stat_online != null">
                        <div class="box-horizontal" v-if="get.data.tipe == 'qris'">
                            <div class="flex-1">
                                <span class="block" style="text-transform:uppercase">
                                    {{get.data.via}}
                                </span>
                                <span class="block mb10" v-if="get.data.stat_online != null">
                                    {{"Invoice #"+get.data.inv}}
                                </span>
                            </div>
                            <div @click="met.qr()" v-if="get.data.stat_online != 'done'">
                                <span class="f10 block gray">Tampilkan</span>
                                <span class="block text-center">
                                    <img src="@/assets/qr.png" alt="" style="height:30px">
                                </span>
                            </div>
                        </div>
                        <div v-else-if="get.data.tipe =='retail' || get.data.tipe =='tripay-retail'">
                            <div class="box-horizontal">
                                <div class="flex-1">
                                    <span class="block" style="text-transform:uppercase">
                                        {{get.data.via}}
                                    </span>
                                </div>
                                <img v-if="get.data.via == 'INDOMARET'" class="icon-bank" src="@/assets/indomaret.png" style="position:absolute;right:20px" />
                                <img v-else class="icon-bank" src="@/assets/alfamart.png" style="position:absolute;right:20px" />
                            </div>
                            <span class="block gray mb5">
                                Kode Penyedia Jasa
                            </span>
                            <div class="box-horizontal">
                                <div class="flex-1">
                                    <span class="block" style="text-transform:uppercase">
                                        {{get.data.merchant}}
                                    </span>
                                </div>
                                <div class="biru salin-btn" @click="met.copy(get.data.merchant)" v-if="get.data.stat_online != 'done'">
                                        Salin
                                </div>
                            </div>
                            <span class="block hitam mb5">
                                Kode Pembayaran
                            </span>
                            <div class="mb10 text-center">
                                <div class="flex-1 mb20">
                                    <strong class="block blue text-center" style="text-transform:uppercase;font-size:15pt">
                                        {{get.data.va}}
                                    </strong>
                                </div>
                                <div class="biru salin-btn" @click="met.copy(get.data.va)" v-if="get.data.stat_online != 'done'">
                                        Salin
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <div class="box-horizontal">
                                <div class="flex-1">
                                    <span class="block" style="text-transform:uppercase">
                                        {{get.data.via}}
                                    </span>
                                </div>
                                <img class="icon-bank" src="@/assets/mandiri.png" v-if="get.data.via == 'MANDIRI'"/>
                                <img class="icon-bank" src="@/assets/bri.png" v-else-if="get.data.via == 'BRI'"/>
                                <img class="icon-bank" src="@/assets/bni.png" v-else-if="get.data.via == 'BNI'"/>
                                <img class="icon-bank" src="@/assets/permata.png" v-else-if="get.data.via == 'PERMATA'"/>
                            </div>
                            <span class="block gray mb5">
                                Kode Penyedia Jasa
                            </span>
                            <div class="box-horizontal">
                                <div class="flex-1">
                                    <span class="block" style="text-transform:uppercase">
                                        {{get.data.merchant}}
                                    </span>
                                </div>
                                
                                <div class="biru salin-btn" @click="met.copy(get.data.merchant)" v-if="get.data.stat_online != 'done'">
                                        Salin
                                </div>
                            </div>
                            <span class="block mb5">
                                Kode Pembayaran
                            </span>
                            <div class="box-horizontal mb10">
                                <div class="flex-1">
                                    <span class="block blue" style="text-transform:uppercase">
                                        {{get.data.va}}
                                    </span>
                                </div>
                                <div class="biru salin-btn" @click="met.copy(get.data.va)" v-if="get.data.stat_online != 'done'">
                                        Salin
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="get.data.stat_online != null && get.data.stat_online != 'done'" class="bg-round-white p10 mt10" @click="met.ganti()">
                    <div class="box-horizontal">
                        <span class="primary-color">Ganti Metode Pembayaran</span>
                    </div>
                </div>
                <div class="bg-round-white p10 mb10 mt10">
                    <span class="block gray mb5" v-if="get.data.stat_online != null">
                        Status
                    </span>
                    <span class="block mt10 mb20" v-if="get.data.stat_online != null"> 
                        <span class="bg-round-green p5 white" v-if="get.data.stat_online == 'done'" >LUNAS</span>
                        <span v-else>
                            <span class="bg-round-yellow p5 white" >PENDING</span>
                        </span>
                    </span>
                    <span class="block gray mb5">
                        Pembayaran Bulan
                    </span>
                    <span class="block hitam mb10">
                        {{get.data.bulan}}
                    </span>
                    <span class="block gray mb5">
                        Total Iuran
                    </span>
                    <span class="block mb10 hitam">
                        {{get.data.total}}
                    </span>
                    <span class="block gray mb5">
                        Paket
                    </span>
                    <span class="block mb10 hitam">
                        {{get.data.paket}}
                    </span>
                    <span class="block gray mb5">
                        Diskon
                    </span>
                    <span class="block mb10 hitam">
                        {{get.data.diskon}}
                    </span>
                    <span class="block gray mb5">
                        PPN
                    </span>
                    <span class="block mb10 hitam">
                        {{get.data.ppn}}
                    </span>
                    <span class="block gray mb5">
                        Biaya Tambahan
                    </span>
                    <span class="block hitam">
                        {{get.data.tambahan1}}
                    </span>
                    <span class="block mb10 hitam">
                        {{get.data.tambahan2}}
                    </span>
                    <span class="block gray mb5">
                        Biaya Admin
                    </span>
                    <span class="block mb10 hitam">
                        {{get.data.biayaadmin}}
                    </span>
                </div>
                <div class="bg-round-white p10 mb10">
                    <span class="block gray mb5">
                        Tanggal Pembayaran
                    </span> 
                    <span class="block mb10 hitam">
                        {{get.data.tanggal}}
                    </span>
                    <span class="block gray mb5">
                        By Admin
                    </span>
                    <span class="block mb10 hitam">
                        {{get.data.byadmin}}
                    </span>
                    <span class=" gray f10">
                        <p class="text-center">
                        JIka anda belum melakukan pembayaran Via Online, tapi anda melakukan pembayaran ke Admin. Maka pembayaran anda akan menjadi pembayaran via Offline / Cash
                        </p>
                    </span>
                </div>
                <div class="bg-round-white btn-red p10 mb10" v-if="get.data.stat_online != null && get.data.stat_online == 'pending'" @click="met.batalkanPembyaran()">
                    <div class="box-horizontal text-center">
                        <span class="block">Batalkan Pembayaran</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="toast" v-show="get.data.toastShow">
            <span class="text-center block w100">{{get.data.toastText}}</span>
        </div>
    </div>
</template>

<script>
import myGlobal from '@/MyGlobal'
import { reactive } from '@vue/composition-api'
import store from '@/store/index'
import inter from '@/Interface'
import router from '@/router'
import Loading from '@/global/Loading' 

export default {
    setup() {
        const get = {
            data: reactive({
                toastShow: false,
                toastText: '',
                this: '',
                params: null,
                bulan: null,
                total: null,
                paket: null,
                diskon: null,
                ppn: null,
                tambahan1: null,
                tambahan2: null,
                biayaadmin: null,
                tanggal: null,
                byadmin: null,
                via: null,
                inv: null,
                stat_online: null,
                qr: null,
                tipe: null, // qris / va
                va: null,
                merchant: null,
                fromWeb: false,
                hid: ""
            }),
            list() {
                var datax = {
                    token: 'TangTung ' //+sessionStorage.getItem('Token')
                };
            
                var apiUrl = inter.KategoriList();

                myGlobal.call(datax,apiUrl).then(x => {
                    //console.log(JSON.stringify(x));
                    //data.loading = false;
                    if (x.status == true) {
                        mainData.data = x.data;
                        //theGet.data.Total = x.pesan;
                    } else {
                        
                    }
                })
            }
        }
        const met = {
            copy(text) {
                if (sessionStorage.getItem("browserToken") != null) {

                    navigator.clipboard.writeText(text);

                    get.data.toastShow = true;
                    get.data.toastText = "Telah tercopy";
                    setTimeout(function() {
                        get.data.toastShow = false;
                    }, 3000);
                } else {
                    myGlobal.android("copy", text);
                }
            },
            batalkanPembyaran() {
                //console.log("Batalin dulu");

                var datax = {
                    token: 'TangTung '+sessionStorage.getItem("tokenu"),
                    qrid: get.data.params.qr_id,
                    hid: get.data.hid
                }

                //
                
                var apiUrl = inter.BatalBayar();

                myGlobal.call(datax,apiUrl).then(x => {

                    //console.log(JSON.stringify(x));

                    if (x.status == true) { 
                        window.history.back();
                    } else {

                    }
                    myGlobal.android("toast", x.pesan);
                    
                })
            },
            ganti() {
                router.push({ 
                    name: 'ganti-metode', 
                    params: {
                        qrid: get.data.params.qr_id,
                    } 
                });
            },
            qr() {
                
                if (sessionStorage.getItem("browserToken") != null) {
                    var params = get.data.params;
                    router.push({ 
                        name: 'success', 
                        params: { 
                            invoice: params.id, 
                            via: params.via, 
                            external_id: params.qr_id, 
                            qr:params.metadata.qr_string
                        } 
                    });
                } else {
                    var datax = {
                        qr: get.data.qr,
                        invoice: get.data.inv
                    }
                }
 
                myGlobal.android("qrcok", datax);
            },
            back() {
                window.history.back();
            }
        }

        const redirectx = {
            checkApp() {
                myGlobal.checkApp();
            },
            now() {
                location.href="#/";
            }
        }

        return {
            met,
            get,
            redirectx
        }

    },
    mounted () {        
        this.redirectx.checkApp();

        var d;
        if (sessionStorage.getItem("rincianDetail") == null) {
            this.get.data.params = this.$route.params.data;

            d = this.get.data.params;

            //console.log(JSON.stringify(d));
            sessionStorage.setItem("rincianDetail", JSON.stringify(this.$route.params.data));
        } else {
            d = JSON.parse(sessionStorage.getItem("rincianDetail"));
            this.get.data.params = d;
        }
        
        
        sessionStorage.removeItem("gantiData");

        this.get.data.hid = d.id;
        //console.log(this.get.data.hid);
        this.get.data.bulan = myGlobal.BulanOnly(d.tanggal);
        this.get.data.total = myGlobal.ribu(d.paket_tarif);
        this.get.data.paket = d.paket_nama;
        this.get.data.diskon = myGlobal.ribu(d.diskon);
        this.get.data.ppn = myGlobal.ribu(d.ppn);
        this.get.data.tambahan1 = d.rincian1 + " @ " + myGlobal.ribu(d.biaya1);
        this.get.data.tambahan2 = d.rincian2 + " @ " + myGlobal.ribu(d.biaya2);
        
            /*
            String[] qride = qrid.split("-");
            total.setText(myGlobals.ribu(obj.getPaketTarif()));

            Integer hasile = Integer.valueOf(qride[9]) - Integer.valueOf(obj.getPaketTarif());
            */

        var hasile;
        if (d.qr_id != null) {
            // MENCARI BIAYA ADMIN
            var qride = d.qr_id.split("-");
            hasile = parseInt(qride[9]) - parseInt(d.paket_tarif);
        } else {
            hasile = 0;
        }

        this.get.data.biayaadmin = myGlobal.ribu(hasile);
        this.get.data.tanggal = myGlobal.tglIndo(d.bayar_tanggal);
        this.get.data.byadmin = d.by_admin;
        this.get.data.via = d.via;
        this.get.data.inv = d.id;
        this.get.data.stat_online = d.stat_via_online;
        this.get.data.qr = d.metadata.qr_string;


        if (d.via == 'MANDIRI' || d.via == "BRI" || d.via == "BCA" || d.via == "BNI" || d.via == "PERMATA") {
            this.get.data.tipe = "va";
            this.get.data.va = d.metadata.account_number;
            this.get.data.merchant = d.metadata.merchant_code;
            //console.log(d.metadata.merchant_code);
        } else if (d.via == 'INDOMARET') {
            this.get.data.tipe = "tripay-retail";
            this.get.data.va = d.metadata.payment_code;
            this.get.data.merchant = "XENDIT";
        } else if (d.via == 'ALFAMIDI') {
            this.get.data.tipe = "tripay-retail";
            this.get.data.va = d.metadata.payment_code;
            this.get.data.merchant = d.metadata.prefix;
        } else if (d.via == 'ALFAMART') {
            this.get.data.tipe = "retail";
            this.get.data.va = d.metadata.payment_code.replace(d.metadata.prefix, "");
            this.get.data.merchant = d.metadata.prefix;
        } else {
            this.get.data.tipe = "qris";
        }
        
    }
}
</script>
<style scoped>
.icon-bank {
    position: absolute !important;
    right:20px !important;
}
.salin-btn {
    padding-top: 5px;
    padding-bottom: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/User/History/detail.vue